import { Module, ModuleVariantsType } from '../../types'

export const createDigitalGiftCardMultipleVariantsConfiguration =
  (): Module[] => {
    return [
      {
        __typename: 'ModuleTwoColumn',
        left: [{ __typename: 'ModuleImages' }],
        right: [
          { __typename: 'ModuleTitle' },
          { __typename: 'ModuleRating' },
          { __typename: 'ModuleFromPrice' },
          { __typename: 'ModulePills' },
          { __typename: 'ModuleKlarnaInfo' },
          { __typename: 'ModuleSellingPoints' },
          { __typename: 'ModuleVariants', type: ModuleVariantsType.GRID },
          { __typename: 'ModuleSelectCard' },
          { __typename: 'ModuleMoreInfo' },
        ],
        ratio: '50/50',
      },
    ]
  }
